export default __webpack_public_path__ + "static/media/brave_zone_background_xl2.73c011ef.jpg";